module.exports = __webpack_public_path__ + "static/media/flag-ms.b8c95335.webp";